export default __webpack_public_path__ + "static/media/error_icon.5aaa7040.svg";